/* eslint-disable import/no-cycle */
import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'budget_service';

export default {
  async create(body) {
    const url = mountUrl(`/${BASE_PATH}`);
    return api.post(url, body);
  },
  async update(budgetId, serviceId, body) {
    const url = mountUrl(`/${BASE_PATH}/${budgetId}/${serviceId}`);
    return api.patch(url, body);
  },
  async inactivate(budgetId, serviceId) {
    const url = mountUrl(`/${BASE_PATH}/${budgetId}/${serviceId}`);
    return api.delete(url);
  }
};
